
<div class="enkai__searchLinks__accordions">
  <h2 class="enkai__searchLinks__accordions__header">条件を指定して{{ prefectureName }}のお店を探す</h2>
  <div class="enkai__searchLinks__accordions__container">
    <div class="title">
      <span>エリアで絞る</span>
      <i class="dropdown icon"></i>
    </div>
    <div class="content">
      <template v-if="areaDetail">
        <a v-for="station in this.stationOptions" :key="station.value" :href="`/${prefectureNameEn}/A${station.area}/AD${station.area_detail}/S${station.value}/`">
          {{ station.label }}
        </a>
      </template>
      <template v-else-if="area">
        <a v-for="areaDetail in this.areaDetailOptions" :key="areaDetail.value" :href="`/${prefectureNameEn}/A${areaDetail.area}/AD${areaDetail.value}/`">
          {{ areaDetail.label }}
        </a>
      </template>
      <template v-else>
        <a v-for="area in areaOptions" :key="area.value" :href="`/${prefectureNameEn}/A${area.value}/`">
          {{ area.label }}
        </a>
      </template>
    </div>
  </div>
  <div class="enkai__searchLinks__accordions__container">
    <div class="title">
      <span>人数で絞る</span>
      <i class="dropdown icon"></i>
    </div>
    <div class="content">
      <a v-for="peopleSearchLink in peopleSearchLinks" :key="peopleSearchLink.text" :href="peopleSearchLink.url">
        {{ peopleSearchLink.text }}
      </a>
    </div>
  </div>
  <div class="enkai__searchLinks__accordions__container">
    <div class="title">
      <span>シーン別で絞る</span>
      <i class="dropdown icon"></i>
    </div>
    <div class="content">
      <a v-for="sceneSearchLink in sceneSearchLinks" :key="sceneSearchLink.text" :href="sceneSearchLink.url">
        {{ sceneSearchLink.text }}
      </a>
    </div>
  </div>
  <div class="enkai__searchLinks__accordions__container">
    <div class="title">
      <span>会場タイプで絞る</span>
      <i class="dropdown icon"></i>
    </div>
    <div class="content">
      <a v-for="shopTypeSearchLink in shopTypeSearchLinks" :key="shopTypeSearchLink.text" :href="shopTypeSearchLink.url">
        {{ shopTypeSearchLink.text }}
      </a>
    </div>
  </div>
</div>
